import React, { ReactNode } from "react";
import { Box, Image } from "@chakra-ui/react";
import { VideoContainer } from "@/components/Video/VideoContainer";

interface MediaThumbnailProps {
  thumbnailUrl: string;
  thumbnailVideoUrl?: string;
  videoUrl?: string;

  badge?: ReactNode;
  badgeSize?: number | string;
}

export const MediaThumbnail: React.FC<MediaThumbnailProps> = ({
  thumbnailUrl,
  thumbnailVideoUrl,
  videoUrl,
}) => (
  <Box
    position="relative"
    aspectRatio={16 / 9}
    overflow="hidden"
    borderRadius="6px"
    w={{ base: "100%", md: "384px" }}
  >
    {videoUrl ? (
      <VideoContainer
        url={videoUrl}
        thumbnailUrl={thumbnailVideoUrl}
        autoPlay
        w="100%"
        h="100%"
        borderRadius="6px"
      />
    ) : (
      <Image
        src={thumbnailUrl}
        alt="program thumbnail"
        w="100%"
        h="100%"
        objectFit="cover"
        borderRadius="6px"
      />
    )}
  </Box>
);
